import '@postscript/components/dist/esm/main.css';
import React from 'react';
import styled from 'styled-components';
import NavMenu from '../Sections/NavMenu';

interface LayoutProps {
  children: React.ReactNode;
}

// Styled Components using Postscript Design System
const LayoutContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--main-bkg-color);
  width: 100%;
`;

const Container = styled.div`
  width: 100%;
`;

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <LayoutContainer>
      <NavMenu />
      <Container>{children}</Container>
    </LayoutContainer>
  );
};

export default Layout;
